import React from 'react'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'

import TitleSection from '../../components/title-section/title-section'
import SectionTC from '../../components/section-tc/section-tc'
import ItemAccordeon from './components/item-accordeon/item-accordeon'

const listAccordeon = [
  {
    id: 1,
    active: true,
    title: 'How do I create my own Salient App account?',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eget bibendum libero. Etiam id velit at enim porttitor facilisis. Vivamus tincidunt lectus at risus pharetra ultrices. In tincidunt turpis at odio dapibus maximus.'
  },
  {
    id: 2,
    active: false,
    title: 'How do I create my own Salient App account?',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eget bibendum libero. Etiam id velit at enim porttitor facilisis. Vivamus tincidunt lectus at risus pharetra ultrices. In tincidunt turpis at odio dapibus maximus.'
  },
  {
    id: 3,
    active: false,
    title: 'How do I create my own Salient App account?',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eget bibendum libero. Etiam id velit at enim porttitor facilisis. Vivamus tincidunt lectus at risus pharetra ultrices. In tincidunt turpis at odio dapibus maximus.'
  },
]

const FrequentQuestions: React.FunctionComponent = () => {
  return (
    <Layout>
        <HeaderOptions />
        <SectionTC>
          <TitleSection title='Frecuentes' preTitle='Preguntas'/>
          {listAccordeon.map(item => (
            <ItemAccordeon title={item.title} description={item.description} active={item.active}/>
          ))}
        </SectionTC>
    </Layout>
  )
}

export default FrequentQuestions